import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.object.to-string.js";
export default {
  name: "RecordLog",
  data: function data() {
    return {
      visible: false
    };
  },
  props: {
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    type: {
      type: String,
      default: ""
    },
    rentList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    reset: function reset() {
      var _this = this;
      // 在浮窗显示后重新计算位置，解决动态内容导致的错位问题
      this.$nextTick(function () {
        if (_this.$refs.popover) {
          _this.$refs.popover.updatePopper();
        }
      });
    },
    // 计算两个经纬度点之间的距离（米），并判断是否超过1000米
    calculateDistance: function calculateDistance(lat1, lng1, lat2, lng2) {
      var R = 6371000; // 地球半径，单位：米
      var dLat = this.toRadians(lat2 - lat1);
      var dLng = this.toRadians(lng2 - lng1);
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(this.toRadians(lat1)) * Math.cos(this.toRadians(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var distance = Math.round(R * c); // 距离，单位：米（取整数）
      return distance > 1000;
    },
    // 角度转弧度
    toRadians: function toRadians(degrees) {
      return degrees * (Math.PI / 180);
    },
    rentTypeName: function rentTypeName(val) {
      var _this$rentList$filter;
      return ((_this$rentList$filter = this.rentList.filter(function (item) {
        return item.id === val;
      })) === null || _this$rentList$filter === void 0 || (_this$rentList$filter = _this$rentList$filter[0]) === null || _this$rentList$filter === void 0 ? void 0 : _this$rentList$filter.name) || "";
    }
  },
  computed: {
    tableWidth: function tableWidth() {
      var width = 500;
      if (this.type === "rentType") {
        width = 240;
      } else if (this.type === "bathroom" || this.type === "bedroom") {
        width = 300;
      }
      return width;
    },
    disabled: function disabled() {
      return this.list.length < 2;
    },
    color: function color() {
      if (this.disabled) return "";
      var name = "";
      var _this$info = this.info,
        rent = _this$info.rent,
        address = _this$info.address,
        latitude = _this$info.latitude,
        longitude = _this$info.longitude,
        rentTypeId = _this$info.rentTypeId,
        bathroom = _this$info.bathroom,
        bedroom = _this$info.bedroom;
      var _ref = this.list[this.list.length - 2] || {},
        oldVal = _ref.rent,
        oldAddress = _ref.address,
        oldLatitude = _ref.latitude,
        oldLongitude = _ref.longitude,
        oldRentType = _ref.rent_type,
        oldBathroom = _ref.bathroom,
        oldBedroom = _ref.bedroom;
      if (this.type === "address") {
        if (address !== oldAddress) {
          // 检查新旧经纬度距离是否大于1000米
          if (latitude && longitude && oldLatitude && oldLongitude) {
            var isDistanceOver = this.calculateDistance(parseFloat(oldLatitude), parseFloat(oldLongitude), parseFloat(latitude), parseFloat(longitude));
            isDistanceOver && (name = "low");
          }
        }
      } else if (this.type === "rentType") {
        if (oldRentType !== rentTypeId) {
          name = "low";
        }
      } else if (this.type === "bathroom") {
        if (oldBathroom !== bathroom) {
          name = "low";
        }
      } else if (this.type === "bedroom") {
        if (oldBedroom !== bedroom) {
          name = "low";
        }
      } else {
        if (rent && oldVal) {
          if (oldVal > rent) {
            name = "low";
          }
          //租金变高 显示绿色
          // else if (oldVal < rent) {
          //     name = "high";
          // }
        }
      }
      return name;
    }
  }
};